import axios from 'axios';
import { jwtDecode } from 'jwt-decode';

/**
 * Configure Axios interceptors to include user ID in all API requests
 * This adds the user ID from the JWT token to either the request headers or body
 */
const setupAxiosInterceptors = () => {
  // Request interceptor
  axios.interceptors.request.use(
    (config) => {
      try {
        const token = localStorage.getItem('token');
        
        // Only proceed if token exists
        if (token) {
          const decoded = jwtDecode(token);
          // Check for both possible user ID field names in the token
          const userId = decoded._id || decoded.userId;
          
          // console.log('Interceptor: Decoded user ID from token:', userId);
          
          // Add user ID to request headers
          config.headers = {
            ...config.headers,
            'User': userId
          };
          
          // console.log('Interceptor: Added user ID to headers:', config.headers);
          
          // If the request has a body and it's not a FormData object, add user ID to body as well
          if (config.data && !(config.data instanceof FormData)) {
            // console.log('Interceptor: Request method:', config.method);
            // Check if config.data is a string (JSON)
            if (typeof config.data === 'string') {
              try {
                const data = JSON.parse(config.data);
                config.data = JSON.stringify({
                  ...data,
                  user: { _id: userId }
                });
                // console.log('Interceptor: Added user ID to request body (JSON string):', config.data);
              } catch (e) {
                // If parsing fails, leave the data as is
                // console.warn('Could not parse request data as JSON');
              }
            } else {
              // It's an object, so we can add the user ID directly
              config.data = {
                ...config.data,
                user: { _id: userId }
              };
              // console.log('Interceptor: Added user ID to request body (object):', config.data);
            }
          }
        } else {
          // console.log('Interceptor: No token found in localStorage');
        }
      } catch (error) {
        // console.error('Error adding user ID to request:', error);
      }
      
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
};

export default setupAxiosInterceptors;